import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { categories } from "../services/apis";
import { apiConnector } from "../services/apiConnector";
import CourseSlider from "../Components/core/Catalog/CourseSlider";
import { getCatalogaPageData } from "../services/operations/pageAndComponentData";
import CatalogCard from "../Components/core/Catalog/CatalogCard";
import { useDispatch } from "react-redux";

const Catalog = () => {
  const params = useParams();
  const displayName = useMemo(
    () => decodeURIComponent(params.catalog || ""),
    [params.catalog]
  );

  const [Desc, setDesc] = useState([]);
  const [CatalogPageData, setCatalogPageData] = useState(null);
  const [categoryID, setcategoryID] = useState(null);
  const [activeOption, setActiveOption] = useState(1);
  const dispatch = useDispatch();

  const fetchSublinks = useCallback(async () => {
    try {
      const result = await apiConnector("GET", categories.CATEGORIES_API);
      const list = result?.data?.data;
      if (!Array.isArray(list)) return;
      const match = list.find((item) => item.name === displayName);
      if (!match?._id) return;
      setcategoryID(match._id);
      setDesc(match);
    } catch (error) {
      console.log("could not fetch sublinks");
      console.log(error);
    }
  }, [displayName]);

  useEffect(() => {
    fetchSublinks();
  }, [fetchSublinks]);

  useEffect(() => {
    const fetchCatalogPageData = async () => {
      const result = await getCatalogaPageData(categoryID, dispatch);
      setCatalogPageData(result);
    };
    if (categoryID) {
      fetchCatalogPageData();
    }
  }, [categoryID, dispatch]);

  const selling = CatalogPageData?.mostSellingCourses;

  return (
    <div className="bg-richblack-5 text-richblack-900">
      <div className="box-content bg-richblack-900 px-4 text-white">
        <div className="mx-auto flex min-h-[220px] max-w-maxContent flex-col justify-center gap-3 py-10">
          <p className="text-sm text-white/70">
            Home / Catalog /{" "}
            <span className="text-yellow-50">{displayName}</span>
          </p>
          <p className="text-3xl font-semibold tracking-tight">{displayName}</p>
          <p className="max-w-[870px] text-base text-white/85">
            {Desc?.description}
          </p>
        </div>
      </div>

      <div className="mx-auto box-content w-full max-w-maxContentTab px-4 py-12 lg:max-w-maxContent">
        <h2 className="mb-1 text-xl font-semibold text-richblack-900 md:text-2xl">
          Courses to get you started
        </h2>
        <div className="my-4 flex border-b border-richblack-200 text-sm">
          <button
            type="button"
            onClick={() => setActiveOption(1)}
            className={
              activeOption === 1
                ? "cursor-pointer border-b-2 border-yellow-50 px-4 py-2 font-medium text-richblack-900"
                : "cursor-pointer px-4 py-2 text-richblack-500 hover:text-richblack-700"
            }
          >
            Most Popular
          </button>
          <button
            type="button"
            onClick={() => setActiveOption(2)}
            className={
              activeOption === 2
                ? "cursor-pointer border-b-2 border-yellow-50 px-4 py-2 font-medium text-richblack-900"
                : "cursor-pointer px-4 py-2 text-richblack-500 hover:text-richblack-700"
            }
          >
            New
          </button>
        </div>
        <CourseSlider Courses={CatalogPageData?.selectedCourses ?? null} />
      </div>

      <div className="mx-auto box-content w-full max-w-maxContentTab border-t border-richblack-200 px-4 py-12 lg:max-w-maxContent">
        <h2 className="mb-6 text-xl font-semibold text-richblack-900 md:text-2xl">
          Similar to {displayName}
        </h2>
        <CourseSlider Courses={CatalogPageData?.differentCourses ?? null} />
      </div>

      <div className="mx-auto box-content w-full max-w-maxContentTab border-t border-richblack-200 px-4 py-12 lg:max-w-maxContent">
        <h2 className="mb-6 text-xl font-semibold text-richblack-900 md:text-2xl">
          Frequently bought together
        </h2>
        {Array.isArray(selling) && selling.length > 0 ? (
          <div className="grid grid-cols-2 gap-3 pr-4 lg:grid-cols-2 lg:gap-6">
            {selling.map((item, index) => (
              <CatalogCard
                key={item?._id || item?.id || index}
                course={item}
                Height={"h-[100px] lg:h-[400px]"}
              />
            ))}
          </div>
        ) : (
          <p className="rounded-xl border border-richblack-200 bg-richblack-5 px-4 py-8 text-center text-richblack-600">
            No bundled courses to show here yet.
          </p>
        )}
      </div>
    </div>
  );
};

export default Catalog;
